<template>
    <form class="alert-horario-especial-form  form-horizontal" @submit.prevent="submit">
        <div class="form-group" :class="{'has-error': errors['name']}">
            <label for="name" class="col-sm-2 control-label">Nombre</label>
            <div class="col-sm-10">
              <input type="text" v-model="data.name" class="form-control" id="name">
               <div class="help-block" v-for="e in errors['name']">{{e}}</div>
            </div>
        </div>
        <div class="form-group" :class="{'has-error': errors['alert']}" >
            <label for="activo" class="col-sm-2 control-label">Alerta</label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="alert" v-model="data.alert"> 
                 <div class="help-block" v-for="e in errors['alert']">{{e}}</div>
            </div>
        </div> 
        <div class="form-group" :class="{'has-error': errors['init_date']}">
            <label for="init_date"  class="col-sm-2 control-label">Visible Desde</label>
            <div class="col-sm-10">
                <el-date-picker
                    v-model="data.init_date"
                    type="date"
                    format="dd-MM-yyyy"
                    placeholder="Seleccione una Fecha"
                    @change="setExpDate">
                </el-date-picker>
                 <div class="help-block" v-for="e in errors['init_date']">{{e}}</div>
            </div>
        </div>
        <div class="form-group" :class="{'has-error': errors['exp_date']}">
            <label for="exp_date"  class="col-sm-2 control-label">Visible Hasta</label>
            <div class="col-sm-10">
                <el-date-picker
                   v-model="data.exp_date"
                    type="date"
                    format="dd-MM-yyyy"
                    placeholder="Seleccione una Fecha"
                    @change="setInitDate">
                </el-date-picker>
                  <div class="help-block" v-for="e in errors['exp_date']">{{e}}</div>
            </div>
        </div>
        <div class="form-group" :class="{'has-error': errors['national']}">
            <label for="nombre" class="col-sm-2 control-label">Cobertura Nacional</label>
            <div class="col-sm-10">
                <el-switch v-model="data.national"  on-text="SI" off-text="NO"></el-switch>
            </div>
        </div>
        <div v-if="!data.national" class="form-group" :class="{'has-error': errors['national']}">
            <label for="region" class="col-sm-2 control-label">Región</label>
            <div class="col-sm-10">
                <el-select filterable v-model="activeRegion" @change="comunas" placeholder="Seleccione una región" style="width:100%">
                    <el-option
                        v-for="(d,key) in groupedData"
                        :key="key"
                        :label="d[0].location.parent.parent.name"
                        :value="d[0].location.parent.parent.id"
                    ></el-option>
                </el-select> 
            </div>
        </div>
         <div v-if="!data.national" class="form-group"  :class="{'has-error': errors['national']}">
            <label for="nombre" class="col-sm-2 control-label">Oficina</label>
            <div class="col-sm-10">
                <multiselect
                v-model="activeComuna"
                tag-placeholder="Agregar Oficina"
                placeholder="Busque y agregue Oficina"
                selectedLabel="Agregado"
                selectLabel="Presiones enter o click para agregar"
                deselectLabel="Presiones enter o click para eliminar"
                noOptions="Sin datos"
                label="name"
                track-by="id"
                :options="comunasFiltradas"
                :multiple="true"
                :taggable="true" 
                :disabled="disabledComuna"  
                >
                <span slot="noOptions">
                    Sin datos
                </span>            
                </multiselect>
                <br>
                <a v-if="activeComuna.length >0 "  @click="addOffice" role="button"><i class="material-icons">add_circle</i> Agregar</a>
                <div class="help-block" style="font-size:12px;">Al cambiar la región se deselecionaran las oficinas</div>
                <div class="help-block" v-for="e in errors['national']">{{e}}</div>
            </div>
        </div>
         <div v-if="!data.national & data.offices.length > 0 " class="form-group" :class="{'has-error': errors['offices']}">
            <label for="nombre" class="col-sm-2 control-label">Oficina Seleccionadas </label>
            <div class="col-sm-10">
                <table class="table">
                    <thead>
                        <tr>
                            <th>Región</th>
                            <th>Oficina</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(o , index) in data.offices" :key="index">
                            <!-- <td>{{o.location.parent.parent.name}}</td> -->
                            <td>{{getNameRegion(o.id)}}</td>
                            <td>{{o.name}}</td>
                            <td>
                                <a @click.prevent="unSelectedOffice(index)" role="button"   title="Borrar"><i class="material-icons">delete</i></a>
                            </td>

                        </tr>
                    </tbody>
                </table>
             </div>
        </div>
        

        <div class="form-group"    >
            <label for="activo" class="col-sm-2 control-label">¿Activo?</label>
            <div class="col-sm-10">
                <el-switch v-model="data.active"  on-text="SI" off-text="NO"></el-switch>
            </div>
        </div>
        <div v-if="data.alert.length>0" class="form-group">
            <label for="previsualizacion" class="col-sm-2 control-label">Previsualización</label>
            <div class="col-sm-offset-2 col-sm-10">
                <i class="material-icons" style="color:red">info</i> <strong>{{data.alert}}</strong>
            </div>
        </div>
         <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
                <a class="btn btn-default" href="backend/oficinas/alertas">Cancelar</a>
                <button type="submit" class="btn btn-primary">Guardar</button>
            </div>
        </div>
    </form>
</template>

<script>
import ElSwitch from 'element-ui/lib/switch';
import OpeningHours from './OpeningHours.vue';
import ElDatePicker from 'element-ui/lib/date-picker';
import ElSelect from 'element-ui/lib/select';
import ElOption from 'element-ui/lib/option';
import Multiselect from "vue-multiselect";


export default {

    data:function(){
        const today = new Date();
        const base_date = new Date(today.getFullYear(),today.getMonth(),today.getDate()); 
        const alert = _.cloneDeep(this.alert);
        const alerta = _.cloneDeep(this.alert);

        // alert.offices =[];

        return {
            data:alert, 
            disabledComuna: true,
            activeRegion: [],
            activeComuna: [],
            comunasFiltradas: [],
            sucursalesFiltradas: [],
            errors: {}
        }
    },
    props: ['offices','alert','edit'],
    components:{
        ElSwitch,
        OpeningHours,
        ElDatePicker,
        ElSelect,
        ElOption,
        Multiselect
    },
    computed:{
        groupedData: function(){
                        return _(this.offices)
                    .groupBy(function(d){
                        return d.location.parent.parent.id;
                    })
                    .values()
                    .orderBy(function(d){
                    return d[0].location.parent.parent.lat;
                 }, 'desc')
                .value();
        },
        validateForm:function(){
            this.errors = {};

            var name = this.data.name === '' || this.data.name === null;
            var name_length = this.data.name.length > 128;
            var alert =  this.data.alert === '' || this.data.alert === null;
            var alert_length = this.data.alert.length >80;
            var date_init = this.data.init_date === '' || this.data.init_date === null || this.data.init_date === undefined;
            var date_exp  = this.data.exp_date === '' || this.data.exp_date === null || this.data.exp_date === undefined;
            var init_date = this.data.init_date > this.data.exp_date;
            var national = !this.data.national && this.data.offices.length == 0;
            var errores ={};

            if(name)
                errores['name']= ['El campo Nombre no puede estar vacío.'];
            
            if(name_length)
                errores['name']= ['El Nombre de la alerta no puede exceder los 128 caracteres.'];
            
            if(alert)
                errores['alert'] = ['El campo Alerta no puede ser vacío.'];

            if(alert_length)
                errores['alert'] = ['El campo Alerta no pude exceder los 80 caracteres.'];

            if(date_init)
                errores['init_date'] = ['Debe ingresar la fecha de Desde'];
            
            if(date_exp)
                errores['exp_date'] = ['Debe ingresar la fecha de Hasta'];

            if(init_date)
                errores['init_date'] = ['La fecha de inicio del período no puede ser mayor a la fecha de término'];
            
            if(national)
                errores['national'] = ['Debe seleccionar al menos una Oficina'];

            if(name || name_length || alert || alert_length || init_date || national || date_init){
                this.errors = errores;
                return true;
            }
            else
                return false;
        }
    },
    methods:{
        comunas: function (selected) {
            if (selected){ 
                this.disabledComuna = false;
                this.activeComuna = []; 
                this.comunasFiltradas=[]; 

                var aux = _(this.offices)
                    .filter(function(d){
                    return d.location.parent.parent_id === selected  && d.mobile === false;
                })
                .groupBy(function(d){
                    return d.location.id;
                })
                .values()
                .orderBy(function(d){
                    return d[0].location.name;
                }, 'asc')
                .value();

                aux.forEach(e => {
                    if(e.length == 1){
                        this.comunasFiltradas.push(e[0]);
                        this.setSelectedOffices(e[0]); 
                    }
                    else{
                        e.forEach(o=>{
                            this.comunasFiltradas.push(o);
                            this.setSelectedOffices(o); 
                        });
                    }
                    
                });


            }
        },
        addOffice : function(){
            var self = this;

            self.activeComuna.forEach(e=>{
                if(!this.data.offices.find(o=> o.id == e.id))
                    this.data.offices.push(e);
            });
            
            this.activeComuna = [];
            this.errors={};
            this.activeRegion = '';
            this.disabledComuna = true;
            
        } ,
        setSelectedOffices:function(office){
            var self = this;

            var oficina = self.data.offices.find(e => e.id == office.id);

            if(oficina)
                self.activeComuna.push(office);  
           

        },
        getNameRegion:function(id){
            return this.offices.find(e => e.id == id).location.parent.parent.name;            
        },
        unSelectedOffice:function(index){
            var self = this;

            self.$confirm('¿Está seguro de quitar la oficina?','Atención',{
                confirmButtonText:'Eliminar',
                cancelButtonText: 'Cancelar',
                type:'warning'
            }).then(() => {
                var selected = self.data.offices[index];
                
                if(selected){
                    var selectedIndex = self.activeComuna.findIndex(e => e.id == selected.id);
                    self.activeComuna.splice(selectedIndex,1);
                }
                self.data.offices.splice(index,1);               
            }).catch();

        },
        setInitDate:function(){
            if(this.data.init_date > this.data.exp_date)
                this.data.init_date = this.data.exp_date;
        },
        setExpDate:function(){

            if(this.data.exp_date < this.data.init_date)
                this.data.exp_date = this.data.init_date;
        },
        submit:function(){
            var self = this;

            if(self.validateForm){
                self.$message.error('Revise los errores en el formulario antes de continuar.');
            }
            else{
                axios({
                    url: self.edit ? 'backend/oficinas/alertas/update':'backend/oficinas/alertas/store',
                    method:self.edit ?'PUT':'POST',
                    data: this.data
                }).then(response => {
                    window.location.replace(response.data.redirect);
                }).catch(function(error){
                    self.error = error.response.data.errors;
                });
            }
        }
    }
}
</script>